export default __webpack_public_path__ + "static/media/Freebooter's Gauntlets of Stalking Fury.55f41fa7.jpg";